import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';

import getFetchOptions from 'utils/getFetchOptions';

//removing sub_id from api func.
export default async function createTests(
	type,
	nKeys,
	groupId,
	language,
	anamnese,
	childSelfStarting,
	isNormingTest
) {
	try {
		const body = {
			type,
			nKeys,
			groupId,
			language,
			anamnese,
			childSelfStarting,
			...(isNormingTest && {isNorming: 1}),
		};

		const response = await fetch(
			`${ENDPOINT_URL}/test/create`,
			getFetchOptions({
				method: 'POST',
				body: JSON.stringify(body),
			})
		);

		if (!response.ok) throw response;

		return await response.json();
	} catch (error) {
		throw apiErrorHandling(error);
	}
}
